// extracted by mini-css-extract-plugin
module.exports = {"CountrySwitcher":"styles_CountrySwitcher__dvy61"};